import Img1 from "./img-1.png";
import Img2 from "./img-2.png";
import Img3 from "./img-3.png";
import Img4 from "./img-4.png";
import Img5 from "./img-5.png";
import Img6 from "./img-6.png";
import Img7 from "./img-7.png";
import Img8 from "./img-8.png";
import Img9 from "./img-9.png";
import Img10 from "./img-10.png";
import Img11 from "./img-11.png";
import Img12 from "./img-12.png";

export const photos = [
  {
    src: Img11,
    width: 4,
    height: 2.5,
  },
  {
    src: Img2,
    width: 1,
    height: 0.7,
  },
  {
    src: Img3,
    width: 4,
    height: 2.7,
  },
  {
    src: Img4,
    width: 4,
    height: 2,
  },
  {
    src: Img5,
    width: 3,
    height: 2,
  },
  {
    src: Img6,
    width: 4,
    height: 2.5,
  },
  {
    src: Img7,
    width: 1,
    height: 0.6,
  },
  {
    src: Img8,
    width: 3,
    height: 1.7,
  },
  {
    src: Img9,
    width: 4,
    height: 2.5,
  },
  {
    src: Img10,
    width: 2,
    height: 1.2,
  },
  {
    src: Img1,
    width: 4,
    height: 2.7,
  },
  {
    src: Img12,
    width: 4,
    height: 3,
  },
];
